export const REPORT_PATH = "/user/woneindex/report";

/**
 * What a link back into a report the learner has already read carries, so
 * the report opens on its content rather than on the cover and the reveal,
 * which only mean something the first time.
 */
export interface ReportLocationState {
  reopened?: boolean;
}
